import { $axios } from 'src/boot/axios';

const state = () => ({
  mobileProfileOpen: false,
  contacts: {},
  providers: [],
  autoresponders: [],
});

const storeGetters = {
  contactsCount: (state) => state.contacts.total || 0,
};

const actions = {
  // Autoresponders
  async fetchAutoresponders({ commit }) {
    const { data } = await $axios.get('autoresponders');
    commit('setAutoresponders', data.data.elements);
  },
  async createAutoresponder({ dispatch }, autoresponder) {
    const { data } = await $axios.post('autoresponders', autoresponder);
    await dispatch('fetchAutoresponders');
    return data;
  },
  async updateAutoresponder({ dispatch }, { id, body }) {
    await $axios.put(`autoresponders/${id}`, body);
    await dispatch('fetchAutoresponders');
  },
  async removeAutoresponder({ dispatch }, id) {
    await $axios.delete(`autoresponders/${id}`);
    await dispatch('fetchAutoresponders');
  },
  async getContacts({ commit }, { params = {} } = {}) {
    const { data } = (await $axios.get('/leads', {
      params: {
        ...params,
        perPage: 10,
      },
    })).data;
    data.page = params.page || 1;
    commit('setContacts', { data });
  },
  async updateContactStatus({ commit }, data) {
    await $axios.put(`/leads/${data.guid}/change-status`, { status: data.status });
    commit('updateContactStatus', data);
  },
  async deleteContact({ dispatch, state }, { leadGuid, params }) {
    await $axios.delete(`leads/${leadGuid}`);

    await dispatch('getContacts', {
      params: {
        page: state.contacts.page,
        ...params,
      },
    });
  },
  async fetchProviders({ commit }) {
    const { data } = await $axios.get('gateways');
    commit('setProviders', data.data.elements);
  },
  async createProvider({ dispatch }, provider) {
    const { data } = await $axios.post('gateways', provider);
    await dispatch('fetchProviders');
    return data;
  },
  async updateProvider({ dispatch }, { id, body }) {
    await $axios.put(`gateways/${id}`, body);
    await dispatch('fetchProviders');
  },
  async removeProvider({ dispatch }, id) {
    await $axios.delete(`gateways/${id}`);
    await dispatch('fetchProviders');
  },

};

const mutations = {
  setAutoresponders(state, payload) {
    state.autoresponders = payload;
  },
  toggleMobileProfile(state) {
    state.mobileProfileOpen = !state.mobileProfileOpen;
  },
  setContacts(state, { data }) {
    state.contacts = data;
  },
  updateContactStatus(state, { scope, guid, status }) {
    const contacts = scope ? state.contacts[scope] : state.contacts;
    const index = contacts.elements.findIndex((contact) => contact.guid === guid);
    if (index > -1) {
      contacts.elements[index].status = status;
    }
  },
  setProviders(state, payload) {
    state.providers = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: storeGetters,
};
